import React, { useEffect } from 'react';
import { useSocket } from './SocketContext';
import addNotification from 'react-push-notification';
import { useNavigate } from 'react-router-dom';
import './Notification.css';

const Notification = () => {
    const socket = useSocket();
    const navigate = useNavigate();

    useEffect(() => {
        if (socket) {
            socket.on('notification', (data) => {
                const { message, route } = data;
                addNotification({
                    title: 'CEP',
                    message: message,
                    icon: 'assets/Images/logo.png', // Optional logo/icon URL
                    theme: 'darkblue', // Optional theme
                    native: true, // Set to true to use the browser's native notification system
                    duration: 10000, // Notification auto-close duration (ms)
                    onClick: () => {
                        if (route) {
                            // Navigate to the specified route if it is provided
                            navigate(route);
                        }
                    }
                });
            });

            return () => {
                socket.off('notification');
            };
        }
    }, [socket, navigate]);

    return null; // This component does not render anything itself
};

export default Notification;
